<div class="h-full flex items-stretch">
  <div class="grow">
    <p-card styleClass="h-full" [style]="style">
      <ng-template #header>
        <div
          class="relative flex items-center justify-center w-full aspect-[16/9] bg-gray-200">
          @if (clips.length) {
            @for (clip of clips.controls; track clip.controls.$key.value) {
              <app-video-clip
                [hidden]="selectedClipIndex !== $index"
                [clip]="clip"
                (clipDelete)="onClipDeleteClick(clip)" />
            }
            @if (clips.length > 1) {
              <div
                class="absolute bottom-0 left-0 right-0 flex items-center justify-between p-1">
                <div class="bg-slate-900 text-white rounded px-1">
                  <span>{{ selectedClipIndex + 1 }}/{{ clips.length }}</span>
                </div>
                <div>
                  <p-button
                    text
                    rounded
                    severity="secondary"
                    icon="pi pi-chevron-left"
                    aria-label="Prev Video Shot Asset"
                    [disabled]="selectedClipIndex === 0"
                    (onClick)="onPrevClipClick()" />
                  <p-button
                    text
                    rounded
                    severity="secondary"
                    icon="pi pi-chevron-right"
                    aria-label="Next Video Shot Asset"
                    [disabled]="selectedClipIndex === clips.length - 1"
                    (onClick)="onNextClipClick()" />
                </div>
              </div>
            }
          } @else if (shot.value.id) {
            <p-button
              text
              rounded
              icon="pi pi-sparkles"
              label="Generate"
              appThrottleClick
              [throttleTime]="500"
              (throttleClick)="onClipGenerateClick()" />
            <p-button
              text
              rounded
              severity="secondary"
              icon="pi pi-upload"
              label="Upload" />
          } @else {
            <p-message icon="pi pi-file-excel" severity="warn" variant="simple">
              Nothing here yet...
            </p-message>
          }
        </div>
      </ng-template>
      <div class="h-[3lh]">
        @if (shot.value.description) {
          <p class="line-clamp-3">{{ shot.value.description }}</p>
        } @else {
          <span class="text-[var(--p-orange-500)]">
            Description is required
          </span>
        }
      </div>
      <ng-template #footer>
        @if (!isGenerating) {
          <div class="text-center">
            @if (shot.value.id) {
              @if (clips.length >= 1) {
                <p-button
                  text
                  rounded
                  icon="pi pi-sparkles"
                  aria-label="Generate Video Clip"
                  appThrottleClick
                  [throttleTime]="500"
                  (throttleClick)="onClipGenerateClick()" />
                <p-button
                  text
                  rounded
                  severity="secondary"
                  icon="pi pi-upload"
                  aria-label="Upload Video Clip" />
              }
              <p-button
                text
                rounded
                icon="pi pi-clone"
                aria-label="Clone"
                (onClick)="onCloneClick()" />
            }
            <p-button
              text
              rounded
              severity="secondary"
              icon="pi pi-pen-to-square"
              aria-label="Edit Video Shot"
              (onClick)="onEditClick()" />
            <p-button
              text
              rounded
              severity="danger"
              icon="pi pi-ban"
              aria-label="Delete Video Shot"
              (onClick)="onDeleteClick()" />
            @if (hasChanges()) {
              <p-button
                text
                rounded
                icon="pi pi-undo"
                severity="warn"
                aria-label="Reset Video Shot"
                (onClick)="onResetClick()" />
            }
            @if (!shot.value.id) {
              <p-button
                text
                rounded
                pTooltip="Not saved yet"
                icon="pi pi-bolt"
                severity="info"
                disabled />
            }
          </div>
        }
      </ng-template>
    </p-card>
  </div>
  <div class="add-video-shot-button flex items-center ml-4">
    <p-button
      rounded
      outlined
      icon="pi pi-plus"
      severity="info"
      aria-label="Add Video Shot"
      (onClick)="onAddClick()" />
  </div>
</div>
